import {
    SEND_BULK_REQUEST,
    SEND_BULK_SUCCESS,
    SEND_BULK_FAILURE,
    CLEAR_BULK_RESULT
} from '../actions/deviceCommands';

const initialState = {
    sending: false,
    summary: null,
    error: null
};

const deviceCommands = (state = initialState, action) => {
    switch (action.type) {
        case SEND_BULK_REQUEST:
            return { ...state, sending: true, error: null, summary: null };
        case SEND_BULK_SUCCESS:
            return { ...state, sending: false, summary: action.payload.summary };
        case SEND_BULK_FAILURE:
            return { ...state, sending: false, error: action.payload.error };
        case CLEAR_BULK_RESULT:
            return initialState;
        default:
            return state;
    }
};

export default deviceCommands;
